import React from 'react'
import "./PastWedding.css"

function PastWedding() {
  return (
    <div>PastWedding</div>
  )
}

export default PastWedding